import { render, staticRenderFns } from "./UserDetailRow.vue?vue&type=template&id=3ea54d7a&"
import script from "./UserDetailRow.vue?vue&type=script&lang=js&"
export * from "./UserDetailRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports